module.exports = require("@material-ui/core/ExpansionPanelSummary");